import { Injectable } from '@angular/core';
import {combineLatest, Observable} from 'rxjs';
import { map } from 'rxjs';
import { FormDefinition  } from '@feature/_app_modules/dynamic-forms/dynamic-form';
import { WidgetConfiguration, WidgetConfigurationsService } from '@feature/widget-configs';
import { WidgetAdminHandler } from '@widget-admin/services/widget-admin-handler';
import { addColumnFieldsToAdminForm, addFilterFieldsToAdminForm, getDefaultWidgetConfigAdminForm } from '@feature/widget-admin/services/widget-admin-form';
import { mapWherePropertiesMatch, QueryBuilderConfigProvider } from '@common/index';
import {WidgetColumnsHttpService} from "@feature/widget-columns/services/widget-columns-http.service";
import { AdminHeadLeaseWidgetFilterFieldProvider } from '../filters/admin-head-lease-schedule-widget-filter-field-provider';
import { CurrencyService } from '@currency/old_index';
import { LeaseDetailsHttpService } from '@feature/leases';

@Injectable({
  providedIn: 'root'
})
export class HeadLeaseScheduleWidgetAdminHandlerService implements WidgetAdminHandler {

  constructor(
    private readonly widgetConfigService: WidgetConfigurationsService,
    private readonly configService: WidgetConfigurationsService,
    private readonly widgetColumnsHttp: WidgetColumnsHttpService,
    private readonly currencySevice: CurrencyService,
  private readonly leaseHttpService: LeaseDetailsHttpService) {
  }

  initialise(): boolean {
    return true;
  }

  getAdminForm(selectedConfig: WidgetConfiguration): FormDefinition | Observable<FormDefinition> {
        
    return combineLatest([this.widgetColumnsHttp.getAllColumns(selectedConfig.id), this.currencySevice.getCurrencies(), this.leaseHttpService.getLeaseTypes()])
      .pipe(map(([columns, currencies, leaseTypes]) => {
        let formDefinition = getDefaultWidgetConfigAdminForm(selectedConfig);

        formDefinition = addColumnFieldsToAdminForm(selectedConfig, columns, formDefinition);
        const filterFieldProvider = new AdminHeadLeaseWidgetFilterFieldProvider(selectedConfig, currencies, leaseTypes);
        const queryConfigProvider = new QueryBuilderConfigProvider(filterFieldProvider);
        const queryConfig = queryConfigProvider.getQueryBuilderConfig();
      
        formDefinition = addFilterFieldsToAdminForm(selectedConfig, queryConfig, formDefinition);

        return formDefinition;
      }));
  }

  createCopyFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue): Observable<boolean> {
    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);

    return this.widgetConfigService.createcopy(copyOfSelectedConfig).pipe(
      map(r => true)
    );
  }

  saveConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);

    return this.widgetConfigService.save(copyOfSelectedConfig).pipe(
      map(r => true)
    );
  }

  deleteConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);

    return this.widgetConfigService.delete(copyOfSelectedConfig).pipe(
      map(r => true)
    );
  }
}
